"use client";

import { useState, useEffect } from 'react';
import { IconLogout } from '@tabler/icons-react';
import classes from './navbar.module.css';
import { NavLink, Box, Flex } from '@mantine/core';
import { clearAuthData } from '@/utils/token';
import { usePathname } from 'next/navigation';
import { data } from './nav_data';

export function NavbarSimple() {
  const [active, setActive] = useState('Dashboard');
  const pathname = usePathname();

  useEffect(() => {
    const activeItem = data.find(item => pathname.startsWith(item.link));
    if (activeItem) {
      setActive(activeItem.label);
    }
  }, [pathname]);

  const handleSignOut = () => {
    try {
      // Clear all stored authentication data
      clearAuthData();
      // Redirect to auth page
      window.location.href = "/auth";
    } catch (error) {
      console.error("Error signing out:", error);
    }
  };

  const links = data.map((item) => (
    <NavLink
      key={item.link}
      href={item.link}
      label={item.label}
      leftSection={<item.icon stroke={1.5} />}
      className={classes.link}
      active={item.label === active}
      onClick={() => setActive(item.label)}
      component="a"
    />
  ));

  return (
    <Flex className={classes.navbarContainer}>
      <Box className={classes.mainNavbar}>
        <Box className={classes.navbarMain}>
          {links}
        </Box>
        <Box className={classes.footer}>
          <NavLink
            label="Logout"
            leftSection={<IconLogout stroke={1.5} />}
            className={classes.link}
            onClick={() => handleSignOut()}
            component="a"
          />
        </Box>
      </Box>
    </Flex>
  );
}
